module.exports = __webpack_public_path__ + "img/button_get_after.4349fb13.png";